import {Contact} from "./BaseTypes.ts";
import React, {useState} from "react";
import mediumSelect2Styles from "./mediumSelect2Styles.ts";
import FuzzyReactSelect from "./Select.tsx";

export function ContactSelector({
                                    name,
                                    contactList,
                                    currentClientId,
                                    selectedContactId,
                                    onChange,
                                    contactIdsToExclude = []
                                }:
                                    {
                                        onChange: (e) => void,
                                        name: string,
                                        contactList: Contact[],
                                        currentClientId: number,
                                        contactIdsToExclude: number[],
                                        selectedContactId: number
                                    }
) {

    const selectedContact = contactList.find(contact => contact.pkContactid === selectedContactId)

    const [currentContactId, setCurrentContactId] = useState<number>(selectedContact?.pkContactid);


    const keyedOptions = {
        'custom': {
            'label': 'Non Contact Recipient',
            'name': 'Non Contact Recipient',
            'value': 0,
            'company': ''
        },
        'cur': {
            'label': 'Client Contacts For Selected Client',
            'options': [],
        },
        'other': {
            'label': 'Client Contacts',
            'options': [],
        },
        'sup': {
            'label': 'Supplier Contacts',
            'options': [],
        },
    };

    const getOptionFromContact = (contact: Contact) => {
        if (!contact) return null;
        return {
            'label': contact.name + ' ' + (contact.supplier?.supCompanyname || contact.client?.cliCompanyname),
            'name': contact.name,
            'value': contact.pkContactid,
            'company': contact.supplier?.supCompanyname || contact.client?.cliCompanyname
        }
    }


    contactList.forEach((contact) => {
        if (contactIdsToExclude.includes(contact.pkContactid) && !(contact.pkContactid == currentContactId)) return;

        const option = getOptionFromContact(contact);
        if (contact.supplier) {
            keyedOptions.sup.options.push(option);
        } else if (contact.client?.pkClientid === currentClientId) {
            keyedOptions.cur.options.push(option);
        } else {
            keyedOptions.other.options.push(option);
        }
    })

    const formatOptionLabel = ({name, company}, {context}) => (
        <div>
            <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                <div style={{width: '100%'}}>{name}</div>
                {context === 'menu' &&
                    <div style={{fontSize: '0.8em', color: "#999"}}>
                        {company}
                    </div>
                }
            </div>
        </div>
    );


    return <FuzzyReactSelect styles={mediumSelect2Styles()} options={Object.values(keyedOptions)}
                             hideSelectedOptions={true}
                             onChange={(v) => {
                                 setCurrentContactId(v.value);
                                 onChange(v);
                             }}
                             defaultValue={selectedContactId === 0 ? keyedOptions['custom'] : getOptionFromContact(selectedContact)}
                             placeholder='Select Contact'
                             formatOptionLabel={formatOptionLabel}
                             name={name}
    />

}
